import { has } from "../../../../utils/menu-context";
import store from "../../../../store";
export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                //if (has({ menuContext, key: "canApprove" }) && (("waitApprove" === record.refStatus?.key  && "notApprove" != record.refStatus?.key) || ("waitAuthen" === record.refStatus?.key && "PEOPLE" === record.refRegisterRole?.key))) {
                if (has({ menuContext, key: "canApprove" }) && (("waitApprove" === record.refStatus?.key || "PEOPLE" === record.refRegisterRole?.key) && "notApprove" != record.refStatus?.key)) {
                    result = true || result;
                }
                if (has({ menuContext, key: "forSendRequest" }) && [undefined, "draft"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canRequestApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (record.isActive === false) return false;
            if (has({ menuContext, key: "forSendRequest" }) && [undefined, "draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }

            return result;
        },
        canAuthenNotApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (record.isActive === false) return false;
            if (has({ menuContext, key: "canApprove" }) && ["waitApprove","waitAuthen"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["addresses.0.refAddressType", "addresses.1.refAddressType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft"].includes(modelRef.refStatus?.key)) {
                    visible = (true || visible);
                }
                return visible;
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "addresses.0.noTh",
                    "addresses.0.soiTh",
                    "addresses.0.roadTh",
                    "addresses.0.mooTh",
                    "addresses.0.refProvince",
                    "addresses.0.refAmphur",
                    "addresses.0.refTambon",
                    "addresses.0.postCode",
                    "addresses.1.noTh",
                    "addresses.1.soiTh",
                    "addresses.1.roadTh",
                    "addresses.1.mooTh",
                    "addresses.1.refProvince",
                    "addresses.1.refAmphur",
                    "addresses.1.refTambon",
                    "addresses.1.postCode",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft"].includes(modelRef.refStatus?.key)) {
                    visible = (true || visible);
                }
                return visible;
            },
        },
        {
            check: ({ field }) => {
                return ["addresses.0.tel", "addresses.0.email", "addresses.1.tel", "addresses.1.email"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return ["refPersonType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refPersonType != null;
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "firstNameTh", 
                    "lastNameTh",
                    "idLine",
                    "refEducation",
                    "refMainOccupation",
                    "refSecondOccupation"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !["1"].includes(modelRef.refPersonType?.key);
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refTitle",
                    "birthDate",
                    "refNationality",
                    "refRace",
                    "refGender",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !["1"].includes(modelRef.refPersonType?.key);
            },
            inputPropField: ({ initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft"],
                })({ initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            },
        },
        {
            check: ({ field }) => {
                return ["idCard"].includes(field?.key);
            },
            inputPropField: ({ initialModel, props }) => {
                const { viewOnly } = props;
                const userInfo = store.state.resource.auth.info?.user;
                if("dev-admin" === userInfo.username && !viewOnly){
                    return { disabled: false }
                }
                const disabled = viewOnly || ![undefined, "draft"].includes(initialModel.refStatus?.key);
                return { disabled: disabled};
            },
        },
        {
            check: ({ field }) => {
                return ["registerDate", "registerCapital", "companyNameTh", "shareholdingTh"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refCompanyType"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            },
            inputPropField: ({ initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft"],
                })({ initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            },
        },
        {
            check: ({ field }) => {
                return ["positionCode", "refPosition", "refDepartment", "refSubDepartment"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficer === true;
            },
        },
        {
            check: ({ field }) => {
                return ["expireDate"].includes(field?.key);
            },
            visibleField: ({ modelRef, data }) => {
                return ["2"].includes(modelRef.refPersonType?.key) || "PEOPLE" === data.registerType;
            },
        },
        {
            check: ({ field }) => {
                return ["attachmentImageIdCardsLib.0", "attachmentImageSignaturesLib.0"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "attachmentIdCards.0",
                    "attachmentSignatures.0",
                    "attachmentImageIdCards.0",
                    "attachmentImageSignatures.0",
                    "cardIdCard",
                    "cardSignature",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef, data }) => {
                return ["2"].includes(modelRef.refPersonType?.key) || "OFFICER" === data.registerType;
            },
        },
        {
            check: ({ field }) => {
                return ["attachmentDocs.0"].includes(field?.key);
            },
            visibleField: ({ data }) => {
                return "OFFICER" === data.registerType;
            },
        },
        {
            check: ({ field }) => {
                return ["userRoleRequests"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { menuContext } = props;
                return has({ menuContext, key: "canApprove" }) ? true : false;
            },
            inputPropField: ({ modelRef, props }) => {
                const { viewOnly } = props
                const userInfo = store.state.resource.auth.info?.user;
                if("dev-admin" === userInfo.username && !viewOnly){
                    return { disabled: false }
                }
                return modelRef.isOfficer != true ? { disabled: true } : {};
            },
        },
        {
            check: ({ field }) => {
                return ["refRegisterRole"].includes(field?.key);
            },
            visibleField: () => {
                const userInfo = store.state.resource.auth.info?.user;
                return "dev-admin" === userInfo.username;
            },
            inputPropField: ({ modelRef, props }) => {
                const { viewOnly } = props
                const userInfo = store.state.resource.auth.info?.user;
                if("dev-admin" === userInfo.username && !viewOnly){
                    return { disabled: false }
                }
                return modelRef.isOfficer != true ? { disabled: true } : {};
            },
        },
        {
            check: ({ field }) => {
                return ["sameAddressType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refSameAddressType?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["buttonLinkUser"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["waitApprove"].includes(modelRef.refStatus?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["spaceIdCard"].includes(field?.key);
            },
            visibleField: ({ modelRef, data, props }) => {
                let visible = false;
                const { viewOnly } = props;
                if ([undefined, "draft"].includes(modelRef.refStatus?.key)) {
                    visible = true;
                    return visible;
                }
                return !("1" === modelRef.refPersonType?.key && "FISHERMAN" === data.registerType) && (!["waitApprove"].includes(modelRef.refStatus?.key) || !viewOnly);
            },
        },
        {
            check: ({ field }) => {
                return ["statusCard"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft"].includes(modelRef.refStatus?.key)) {
                    visible = true;
                }
                return visible
            },
        },
        {
            check: ({ field }) => {
                return ["refStatus", "refConfirmBy"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return ["remark"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (modelRef.remark) {
                    visible = true;
                }
                return visible
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
    ];
};

export const commonInputPropField =
    ({ disabledStatuses }) =>
    ({ initialModel }) => {
        let enabled = undefined;
        if (disabledStatuses.includes(initialModel.refStatus?.key)) {
            enabled = false;
        }
        return { disabled: enabled !== undefined ? !enabled : undefined };
    };
